import { render, staticRenderFns } from "./lorem-ipsum.vue?vue&type=template&id=01b690f4&"
import script from "./lorem-ipsum.vue?vue&type=script&lang=js&"
export * from "./lorem-ipsum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports